var map = {
	"./baroque.webp": 19062,
	"./elegant-silence.webp": 59793,
	"./grace.webp": 46385,
	"./illustration.webp": 79281,
	"./impressionism-1.webp": 43367,
	"./oil-painting.webp": 260,
	"./sketch-1.webp": 5473,
	"./watercolor-1.webp": 38399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96189;